module.exports = __webpack_public_path__ + "images/winner.svg?2d2de58fd981cb73a25dec9364e836c5";


//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/views/progress/components/result/components/progress/components/icons/images/winner.svg
// module id = 8ef220677aaa16af1c02
// module chunks = 11